import styled from 'styled-components'

import { Title } from '../../components/Results'

export const CustomerTitle = styled(Title)`
  display: flex;
  justify-content: space-between;
`
